// extracted by mini-css-extract-plugin
module.exports = {"confirmationText":"PopUp_confirmationText__1d-rt","saveButton":"PopUp_saveButton__BUvFL","downloadButton":"PopUp_downloadButton__2KHzD"};